/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type IndexResponse = {
  app: number;
  destination: number;
  date: string;
  price: number;
  clicks: number;
  impressions: number;
  directConversions: number;
  ctr: number;
  cpc: number;
  cpm: number;
  cpa: number;
  cvr: number;
};

export type IndexParams = {
  appId: number;
  startAt: string;
  endAt: string;
};

export class Api {
  public static index(developerId: number, params: IndexParams) {
    return request.get<IndexResponse[]>(
      `/developers/${developerId}/ad_reports`,
      params
    );
  }
}
